import TutorFavoriteTogglerFromDetails from './TutorFavoriteTogglerFromDetails';

export default TutorFavoriteTogglerFromDetails;
